"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nativeShare = nativeShare;

require("core-js/modules/es6.promise");

var _config = require("../config");

var _utils = _interopRequireDefault(require("../utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function nativeShare(opts) {
  return new Promise(function (resolve, reject) {
    var WLShare = window.WLSDK.WLShare;

    if (WLShare) {
      var _cancel = opts.cancel,
          _click = opts.click,
          _shareSuccess = opts.shareSuccess;

      var shareInfo = opts.shareInfo || _utils.default.getNativeShareConfig(opts);

      var platforms = opts.platforms || _config.SHARE.platforms;
      var platform = 'no';
      WLShare.startShare({
        platforms: platforms,
        iOSContent: shareInfo,
        cancel: function cancel() {
          _cancel && _cancel({
            platform: platform
          });
        },
        click: function click(resp) {
          platform = resp.content.platform; // 拼接并执行native分享方法

          WLShare["shareTo".concat(platform)] && WLShare["shareTo".concat(platform)](shareInfo[platform]);
          _click && _click({
            platform: platform
          });
        },
        shareSuccess: function shareSuccess() {
          _shareSuccess && _shareSuccess({
            platform: platform
          });
        }
      }).then(resolve).catch(reject);
    } else {
      reject();
    }
  });
}